import { ContractCategory } from '../types/categories';


// get number of months left of a contract
export const getMonthsLeftOfContract = (contractExpiration: string, when?: string): number | undefined => {
  if (!contractExpiration) return undefined;

  const expirationDate = new Date(contractExpiration);
  const currentDate = when ? new Date(when) : new Date();

  const startYear = currentDate.getFullYear();
  const startMonth = currentDate.getMonth();

  const endYear = expirationDate.getFullYear();
  const endMonth = expirationDate.getMonth();

  const monthsLeft = (endYear - startYear) * 12 + (endMonth - startMonth);

  return Math.max(0, monthsLeft);
};


// get contract category based on contract expiration date
export const getContractCategory = (contractExpiration: string, when?: string): ContractCategory | undefined => {
  if (!contractExpiration) return undefined;

  const referenceYear = when ? when.split('-')[0] : new Date().toISOString().split('-')[0];
  const expirationYear = contractExpiration.split('-')[0];

  const yearDiff = Number(expirationYear) - Number(referenceYear);

  if (yearDiff !== undefined) {
    if (yearDiff < 1) return 'U1';
    if (yearDiff < 2) return 'U2';
    if (yearDiff < 3) return 'U3';
    return '3+';
  }
};


// contract categories are displayed by expiration year
export const getDisplayContractCategory = (contractCategory: ContractCategory | undefined, when?: string) => {
  if (!contractCategory) return undefined;

  const referenceYear = when ? when.split('-')[0] : new Date().toISOString().split('-')[0];
  if (contractCategory === 'U1') return `${referenceYear}`;
  if (contractCategory === 'U2') return `${Number(referenceYear) + 1}`;
  if (contractCategory === 'U3') return `${Number(referenceYear) + 2}`;
  return `${Number(referenceYear) + 3}`;
};


// get a value between 0 and 10 based on months left of contract expiration
export const getMonthsLeftOfContractIndexEquivalent = (
  monthsLeftOfContract: number | undefined,
  minMonths?: number,
  maxMonths?: number,
): number | undefined => {
  if (monthsLeftOfContract === undefined) return undefined;

  const minMonthsToUse = minMonths ?? 6;
  const maxMonthsToUse = maxMonths ?? 48;

  const minDaysLeft = minMonthsToUse * 30;
  const maxDaysLeft = maxMonthsToUse * 30;

  const daysLeft = Math.min(maxDaysLeft, Math.max(minDaysLeft, monthsLeftOfContract * 30));

  const percent = (daysLeft - minDaysLeft) / (maxDaysLeft - minDaysLeft);
  return percent * 10;
};


// get a value between 0 and 10 based on the contract expiration
export const getContractExpirationIndexEquivalent = (
  contractExpiration: string | undefined,
  minMonths?: number,
  maxMonths?: number,
): number | undefined => {
  if (!contractExpiration) return undefined;
  const monthsLeftOfContract = getMonthsLeftOfContract(contractExpiration);
  return getMonthsLeftOfContractIndexEquivalent(monthsLeftOfContract, minMonths, maxMonths);
};


// get a value between 0 and 10 based on the contract category
export const getContractCategoryIndexEquivalent = (contractCategory: ContractCategory | undefined): number | undefined => {
  if (contractCategory === '3+') return 10;
  if (contractCategory === 'U3') return 6;
  if (contractCategory === 'U2') return 3;
  if (contractCategory === 'U1') return 0;
};
